module.exports = "<p>This is the Server Profile for this server.</p>\n\n<asui-table class=\"serverProfileTable\" options=\"$ctrl.table.options\" items=\"$ctrl.elements\">\n        <no-data-content><div class=\"center\">No Data Available</div></no-data-content>\n</asui-table>\n<div class=\"margin-t-10\">\n<as-copy  text=\"$ctrl.serverProfilePayload\" hidecopybutton=\"$ctrl.hidecopybutton\"></as-copy>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./modules/license/features/license-server-profile/licenseServerProfile.component.html
// module id = 621
// module chunks = 0